module.exports = __webpack_public_path__ + "img/slide-44.2b03675d.jpeg";